import React, { useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  DialogContentText,
  Box,
  Avatar,
  useTheme,
  useMediaQuery,
  Slide,
} from '@mui/material';
import { ArrowBack, ArrowForward, Block, Close, Description, Person } from '@mui/icons-material';
import { variants } from '../../../variants/variants';
import AttachmentGallery from '../../../common/Utility/AttachmentGallery ';
import defaultimg from '../../../common/default.png';

const ShabashWinnerDialog = ({ open, onClose, data }) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const scrollContainerRef = useRef(null);

  const slideTransition = {
    TransitionComponent: Slide,
    TransitionProps: {
      direction: 'up',
    },
  };

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  return (
    <Dialog
      fullScreen={isSm}
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      {...(isSm ? slideTransition : {})}
      transitionDuration={300}
      keepMounted
      aria-describedby="slide-up animation"
    >
      <DialogTitle
        sx={{
          backgroundColor: 'white',
          color: 'black',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: isSm ? '16px' : '20px',
          fontWeight: '600',
          padding: isSm ? '12px 16px' : '16px 24px',
          borderBottom: '0.5px dotted lightgrey',
          marginBottom: '0.5rem',
        }}
      >
        Winner Details
        <IconButton {...(open && { className: 'backButton' })} onClick={onClose} size="small" sx={{ color: 'black' }}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: isSm ? '12px' : '24px', objectFit: '' }}>
        {data && (
          <>
            <DialogContentText fontSize={variants.fontSize.SUB_HEADING}>
              <Box display="flex" alignItems="center" mb={2}>
                <Person sx={{ marginRight: '8px', color: 'grey' }} />
                <Typography
                  // component={'span'}
                  sx={{ fontSize: isSm ? '14px' : 'inherit', color: 'black' }}
                >
                  <strong>Awarded by</strong> {data.nominatorName}
                </Typography>
              </Box>
            </DialogContentText>
            <Box display="flex" alignItems="center" mb={2}>
              <Description sx={{ marginRight: '8px', color: 'grey' }} />
              <Typography sx={{ fontSize: isSm ? '14px' : 'inherit', color: 'black' }}>
                <strong>Nomination Reason : </strong> {data.nominationReason}
              </Typography>
            </Box>
            <Box mt={2}>
              <Typography variant="body1" sx={{ fontSize: isSm ? '14px' : 'inherit', marginBottom: '8px' }}>
                <strong>Attachment :</strong>
              </Typography>

              {console.log('data in shabash:', data)}
              <AttachmentGallery attachments={data.attachment} isDetailScreen={true} defaultimg={defaultimg} />
            </Box>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ShabashWinnerDialog;
